import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  const stats = [
    { icon: 'ri-user-3-line', label: t('about.guests') },
    { icon: 'ri-hotel-bed-line', label: t('about.bedrooms') },
    { icon: 'ri-drop-line', label: t('about.bathrooms') },
    { icon: 'ri-footprint-line', label: t('about.pets') },
  ];

  return (
    <section id="about" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
            <div className="w-full lg:w-1/2">
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=Cozy%20holiday%20home%20exterior%20with%20traditional%20thatched%20roof%20in%20north%20sea%20coastal%20village%2C%20green%20garden%20with%20wooden%20terrace%2C%20warm%20sunny%20day%2C%20natural%20beige%20and%20green%20tones%2C%20editorial%20photography%2C%20high%20detail%2C%20soft%20natural%20lighting&width=800&height=600&seq=haus-aussen-01&orientation=landscape"
                  alt={t('gallery.altExterior')}
                  className="w-full h-[350px] md:h-[450px] object-cover rounded-lg"
                />
                <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 w-32 h-32 md:w-40 md:h-40 rounded-lg overflow-hidden border-4 border-background-50">
                  <img
                    src="https://readdy.ai/api/search-image?query=Sunny%20wooden%20terrace%20with%20garden%20furniture%2C%20potted%20plants%2C%20green%20lawn%20view%2C%20warm%20afternoon%20light%2C%20natural%20beige%20and%20green%20tones%2C%20editorial%20photography%2C%20cozy%20atmosphere%2C%20high%20detail&width=400&height=400&seq=terrasse-01&orientation=squarish"
                    alt={t('gallery.altTerrace')}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            <div className="w-full lg:w-1/2">
              <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase">
                {t('about.badge')}
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-3">
                {t('about.title')}
              </h2>
              <div className="mt-6 space-y-4 text-foreground-700 leading-relaxed">
                <p>{t('about.description1')}</p>
                <p>{t('about.description2')}</p>
              </div>

              <div className="mt-8 grid grid-cols-2 gap-4">
                {stats.map((stat) => (
                  <div
                    key={stat.label}
                    className="flex items-center gap-3 p-3 bg-background-100 rounded-lg"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0">
                      <i className={`${stat.icon} text-lg`} />
                    </div>
                    <span className="text-sm font-medium text-foreground-800">
                      {stat.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}